import React from 'react'

// Small solid-style label for product cards / lists.
// Tones: brand | accent | success | danger | warning | neutral | dark
// Sizes: sm | md

const TONE = {
  brand:   'bg-brand-600 text-white',
  accent:  'bg-accent-500 text-white',
  success: 'bg-success-600 text-white',
  danger:  'bg-danger-600 text-white',
  warning: 'bg-warning-500 text-white',
  neutral: 'bg-slate-700 text-white',
  dark:    'bg-slate-900 text-white',
  // soft variants
  brandSoft:   'bg-brand-50 text-brand-700',
  accentSoft:  'bg-accent-50 text-accent-700',
  successSoft: 'bg-success-50 text-success-700',
  dangerSoft:  'bg-danger-50 text-danger-700',
  warningSoft: 'bg-warning-50 text-warning-700',
  neutralSoft: 'bg-slate-100 text-slate-700',
}

const SIZE = {
  sm: 'text-[10px] px-2 py-0.5',
  md: 'text-xs    px-2.5 py-1',
}

const Badge = ({
  tone = 'brand',
  size = 'sm',
  icon,
  className = '',
  children,
  ...rest
}) => {
  const cls = [
    'inline-flex items-center gap-1 font-bold uppercase tracking-wide rounded-pill whitespace-nowrap',
    TONE[tone] || TONE.brand,
    SIZE[size] || SIZE.sm,
    className,
  ].join(' ')

  return (
    <span className={cls} {...rest}>
      {icon && <span className='inline-flex shrink-0'>{icon}</span>}
      {children}
    </span>
  )
}

export default Badge
